import DepositIcons from '@/icons/DepositIcons'
import InvoicableIcons from '@/icons/InvoicableIcons'
import InvoiceIcons from '@/icons/InvoiceIcons'
import LoadIcons from '@/icons/LoadIcons'
// import MailIcons from '@/icons/MailIcons'
import NonInvoicableIcons from '@/icons/NonInvoicableIcons'
// import WatchIcons from '@/icons/WatchIcons'
import InvoiceDeposit from './Deposit'
import Index from './Index/index'
import Invoicable from './Invoicable'
import NonInvoicable from './NonInvoicable'
// import StatmentService from './StatmentService'
import WaitingConfirm from './WaitingConfirm'
import { TFunction } from 'i18next'

export const tabs = (t: TFunction) => [
    {
        label: t('list-invoice'),
        value: 'list-invoice',
        startIcon: <InvoiceIcons />,
        component: <Index />,
    },
    {
        label: t('waiting-confirm-invoice'),
        value: 'waiting-confirm-invoice',
        startIcon: <LoadIcons />,
        component: <WaitingConfirm />,
    },
    {
        label: t('non-invoicable'),
        value: 'non-invoicable',
        startIcon: <NonInvoicableIcons />,
        component: <NonInvoicable />,
    },
    {
        label: t('invoicable'),
        value: 'invoicable',
        startIcon: <InvoicableIcons />,
        component: <Invoicable />,
    },
    {
        label: t('deposit-invoice'),
        value: 'deposit-invoice',
        startIcon: <DepositIcons />,
        component: <InvoiceDeposit />,
    },
    // {
    //     label: 'statment-invoice-service',
    //     value: 'statment-invoice-service',
    //     startIcon: <WatchIcons  />,
    //     component: <StatmentService />,
    // },
    // {
    //     label: 'email-invoice',
    //     value: 'service',
    //     startIcon: <MailIcons  />,
    //     component: <></>,
    // },
]
